//Lấy DNS môi trường
// process.env.VUE_APP_SERVERHOST = location.hostname;
// process.env.VUE_APP_SERVERHOST = ''

//*** DEV ***//
const hostDev = 'http://localhost:54472/api';

//*** Local ***//
const hostLocal ='/APIS/PlatformAPI/api';

//*** Test ***//
const hostTest ='/APIS/PlatformAPI/api';

//*** Production ***//
const hostProduction ='/APIS/PlatformAPI/api';

const api = {
  development: hostDev,
  local: hostLocal,
  test: hostTest,
	production: hostProduction
};

export default api[process.env.NODE_ENV];
